import { Controller } from 'stimulus'

//
//   data: { controller: "busy", action: "click->busy#start" }
export default class extends Controller {

  connect() {
    this.reset = this.reset.bind(this)
    window.addEventListener('pageshow', this.reset)
  }

  disconnect() {
    window.removeEventListener('pageshow', this.reset)
  }

  start() {
    if (this.element.classList.contains('is-busy')) return

    this.element.classList.add('is-busy')

    const icon = this.element.querySelector('i')
    if (!icon) return

    this.previousIcon = icon.className
    icon.className = 'fa fa-circle-notch fa-spin'
  }

  reset() {
    this.element.classList.remove('is-busy')

    const icon = this.element.querySelector('i')
    if (icon && this.previousIcon) icon.className = this.previousIcon
  }
}
